import { Icon } from 'semantic-ui-react';
import styles from '../Components/styles/InventoryOverviewPopup.module.scss';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { defaultDateFormatJustDate } from 'Dates';

type Props = {
  contact: any;
  showPersonalData?: boolean;
};

const formatExpiryDate = (date: string | undefined | null): string | null => {
  if (!date) return null;
  return moment(date).format(defaultDateFormatJustDate);
};

const isExpired = (date: string | undefined | null): boolean => {
  if (!date) return false;
  return moment(date).isBefore(moment());
};

const PersonPopupContent = ({ contact, showPersonalData }: Props) => {
  const { portablePhone, telephone1, email, awarenessExpiryDate, handlingExpiryDate } = contact;
  const { t } = useTranslation();

  const awarenessFormatted = formatExpiryDate(awarenessExpiryDate);
  const handlingFormatted = formatExpiryDate(handlingExpiryDate);
  const awarenessIsExpired = isExpired(awarenessExpiryDate);
  const handlingIsExpired = isExpired(handlingExpiryDate);
  const hasExpiryInfo = awarenessFormatted || handlingFormatted;

  return (
    <>
      <div>
        {portablePhone !== null && (
          <div>
            <Icon name="mobile alternate" />
            {showPersonalData ? portablePhone : 'XXXXX'}
          </div>
        )}

        {telephone1 !== null && (
          <div>
            <Icon name="phone" />
            {showPersonalData ? telephone1 : 'XXXXX'}
          </div>
        )}

        {email !== null && (
          <div className={styles.inlineElements}>
            <Icon name="mail" />
            {showPersonalData ? email : 'XXXXX'}
          </div>
        )}

        {hasExpiryInfo && (
          <div className={styles.competencySection}>
            <div className={styles.competencyHeader}>
              <Icon name="certificate" />
              {t('message.person.training.expiration.title')}
            </div>
            {awarenessFormatted && (
              <div className={awarenessIsExpired ? styles.competencyExpired : styles.competencyValid}>
                <Icon name={awarenessIsExpired ? 'warning sign' : 'check circle'}
                  color={awarenessIsExpired ? 'red' : 'green'} size="small" />
                {t('message.person.training.awareness')}: {awarenessFormatted}
              </div>
            )}
            {handlingFormatted && (
              <div className={handlingIsExpired ? styles.competencyExpired : styles.competencyValid}>
                <Icon name={handlingIsExpired ? 'warning sign' : 'check circle'}
                  color={handlingIsExpired ? 'red' : 'green'} size="small" />
                {t('message.person.training.handling')}: {handlingFormatted}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default PersonPopupContent;
